import { ElementRef } from '@angular/core';
import { ScreenSize } from 'app/models/common/screenSize';

export interface LayoutState {
  totalScreenSize: ScreenSize,
  totalWindowWidth: number,
  totalWindowHeight: number,
  sidenavOpened: boolean,
  popoverWidth: number,
  popoverDocked: boolean,
  toolbarZindex: number,
  globalReference: ElementRef;
}

export const initialLayoutState: LayoutState = {
  totalScreenSize: new ScreenSize(),
  totalWindowWidth: 0,
  totalWindowHeight: 0,
  sidenavOpened: false,
  popoverWidth: 0,
  popoverDocked: false,
  toolbarZindex: 10,
  globalReference: null
}